// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Evjm","tab":"ProcedureTabs_tab__198Zr"};